<template>
    <div class="app-landing-brand-logo-area section-space--ptb_50">
                <div class="section-title-wrapper text-center section-space--mb_60">
                    <h2 class="section-title mb-30 wow move-up">Find what works<br>for you</h2>
                </div>
        <div class="icon-process-wrapper ">
            <div class="icon-process-single wow move-up">
                <div class="icon-process-single__line">
                    <div class="dot dot-1"></div>
                    <div class="dot dot-2"></div>
                    <div class="dot dot-3"></div>
                    <div class="dot dot-4"></div>
                    <div class="dot dot-5"></div>
                    <div class="dot dot-4"></div>
                    <div class="dot dot-3"></div>
                    <div class="dot dot-2"></div>
                    <div class="dot dot-1"></div>
                </div>
                <div class="icon-process-single__content-wrap">
                    <div class="icon-process-single__media">
                        <i class="fa fa-bolt"></i>
                    </div>
                    <h4 class="icon-process-single__title">{{ $t('title1') }}</h4>
                    <div class="icon-process-single__text">
                        {{ $t('text1') }} 
                    </div>
                </div>
            </div>
            <div class="icon-process-single wow move-up">
                <div class="icon-process-single__line">
                    <div class="dot dot-1"></div>
                    <div class="dot dot-2"></div>
                    <div class="dot dot-3"></div>
                    <div class="dot dot-4"></div>
                    <div class="dot dot-5"></div>
                    <div class="dot dot-4"></div>
                    <div class="dot dot-3"></div>
                    <div class="dot dot-2"></div>
                    <div class="dot dot-1"></div>
                </div>
                <div class="icon-process-single__content-wrap">
                    <div class="icon-process-single__media">
                        <i class="fa fa-vial primary"></i>
                    </div>
                    <h4 class="icon-process-single__title">{{ $t('title2') }}</h4>
                    <div class="icon-process-single__text">
                        {{ $t('text2') }}
                    </div>
                </div>
            </div>
            <div class="icon-process-single wow move-up">
                <div class="icon-process-single__line">
                    <div class="dot dot-1"></div>
                    <div class="dot dot-2"></div>
                    <div class="dot dot-3"></div>
                    <div class="dot dot-4"></div>
                    <div class="dot dot-5"></div>
                    <div class="dot dot-4"></div>
                    <div class="dot dot-3"></div>
                    <div class="dot dot-2"></div>
                    <div class="dot dot-1"></div>
                </div>
                <div class="icon-process-single__content-wrap">
                    <div class="icon-process-single__media">
                        <i class="fa fa-chart-line"></i>
                    </div>
                    <h4 class="icon-process-single__title">{{ $t('title3') }}</h4>
                    <div class="icon-process-single__text">
                        {{ $t('text3') }}
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default{
        name: 'PatientGradation',
    };
</script>


<i18n>
{
  "en": {
    "title1": "Track",
    "text1": "Track with ease what you eat, your symptoms and everything else that matters.",
    "title2": "Test",
    "text2": "We analyse your data and identify lifestyle changes that may increase you well-being. We then help you during the experimentation.",
    "title3": "Learn",
    "text3": "At the end of the experimentation you know yourself better."
  },
  "fr": {
    "title1": "Suivez",
    "text1": "Suivez facilement ce que vous mangez, vos symptômes et tout ce qui compte.",
    "title2": "Testez",
    "text2": "Nous analysons vos données et identifions les changements de mode de vie susceptibles d'accroître votre bien-être. Nous vous accompagnons ensuite pendant l'expérimentation.",
    "title3": "Apprenez",
    "text3": "À la fin de l'expérimentation, vous vous connaissez mieux."
  }
}
</i18n>
